import React from "react"

import { Element } from "legacy/components/shared/base"
import HeroButton from "./HeroButton"
import { Maybe } from "types/Maybe"
import { PrismicPageDataBodySplitHeroItemType } from "types/__generated__/gatsby-graphql"

interface OwnProps {
  data: Maybe<Array<Maybe<PrismicPageDataBodySplitHeroItemType>>>
}

type HeroButtonsProps = OwnProps

const HeroButtons: React.FC<HeroButtonsProps> = ({
  data,
}): React.ReactElement | null => {
  if (!data) return null

  return (
    <Element mb={["30", "50", "0"]}>
      {data.map((button, index) => {
        const buttonText = button?.button_text
        const buttonUrl = button?.button_url
        const isLast = index === data.length - 1

        if (buttonText && buttonUrl) {
          return (
            <HeroButton
              key={`hero_button_${index}`}
              lastItem={isLast}
              text={buttonText}
              url={buttonUrl}
            />
          )
        }
      })}
    </Element>
  )
}

export default HeroButtons
